const getDeedTypeForDisplay = (deedType: string) => {
  switch (deedType) {
    case 'Campaign':
      return 'Fundraiser';

    case 'Event':
      return 'Volunteer Event';

    case 'BaseEvent':
      return 'Event';

    case 'Project':
    default:
      return deedType;
  }
};

export default getDeedTypeForDisplay;
